<template>
  <div class="propagation-modal box">
    <header class="propagation-modal__header">
      <h3 class="title is-5">
        Propager les modifications
      </h3>
      <p class="propagation-modal__intro">
        Ce plan d'abonnement a des abonnés actifs. Comment voulez-vous appliquer ce changement ?
      </p>
    </header>

    <section class="propagation-modal__choices">
      <article
        class="propagation-modal__choice"
        role="button"
        tabindex="0"
        @click="select(true)"
        @keyup.enter.prevent="select(true)"
        @keyup.space.prevent="select(true)"
      >
        <div class="propagation-modal__choice-body">
          <h4>Synchroniser pour tout le monde</h4>
          <p>
            Les abonnés actuels recevront (ou perdront) l'accès à ce contenu.
          </p>
        </div>
        <b-button type="is-primary" expanded @click.stop="select(true)">
          Synchroniser pour tout le monde
        </b-button>
      </article>

      <article
        class="propagation-modal__choice"
        role="button"
        tabindex="0"
        @click="select(false)"
        @keyup.enter.prevent="select(false)"
        @keyup.space.prevent="select(false)"
      >
        <div class="propagation-modal__choice-body">
          <h4>Pour les nouveaux abonnés uniquement</h4>
          <p>
            Ce changement n'affectera pas les abonnés existants.
          </p>
        </div>
        <b-button type="is-light" expanded @click.stop="select(false)">
          Pour les nouveaux abonnés uniquement
        </b-button>
      </article>
    </section>

    <footer class="propagation-modal__footer">
      <b-button type="is-text" size="is-small" expanded @click="cancel">
        Annuler
      </b-button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'PropagationConfirmModal',
  props: {
    onSelect: {
      type: Function,
      required: true,
    },
  },
  methods: {
    select(value) {
      this.onSelect(value);
    },
    cancel() {
      this.onSelect(null);
    },
  },
};
</script>

<style scoped>
.propagation-modal {
  width: min(820px, calc(100vw - 2rem));
  padding: 2rem;
  margin: 0 auto;
}

.propagation-modal__intro {
  margin-top: 0.5rem;
  color: #4a4a4a;
}

.propagation-modal__choices {
  display: grid;
  grid-template-columns: repeat(2, minmax(320px, 1fr));
  gap: 1.5rem;
  margin: 2rem 0;
}

.propagation-modal__choice {
  display: grid;
  gap: 1rem;
  padding: 1.5rem;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(10, 10, 10, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  cursor: pointer;
}

.propagation-modal__choice:focus {
  outline: none;
  border-color: #7957d5;
  box-shadow: 0 0 0 2px rgba(121, 87, 213, 0.2);
}

.propagation-modal__choice-body {
  display: grid;
  gap: 0.5rem;
}

.propagation-modal__choice-body h4 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  color: #1f2d3d;
}

.propagation-modal__choice-body p {
  margin: 0;
  color: #4a4a4a;
}

.propagation-modal__footer {
  margin-top: 1.5rem;
}

@media (max-width: 640px) {
  .propagation-modal__choices {
    grid-template-columns: 1fr;
  }
}
</style>
